import { render, staticRenderFns } from "./RecipientMobileEs.vue?vue&type=template&id=7024b39c&scoped=true&"
import script from "./RecipientMobileEs.vue?vue&type=script&lang=js&"
export * from "./RecipientMobileEs.vue?vue&type=script&lang=js&"
import style0 from "./RecipientMobileEs.vue?vue&type=style&index=0&id=7024b39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024b39c",
  null
  
)

export default component.exports